import { SearchParams } from '@components/CustomerSearch/components/CustomerSearchBox/CustomerSearchBox';
import { proxy, subscribe } from 'valtio';

type InboxState = {
  selectedTaskId: string | undefined;
  previousSelectedTaskId: string | undefined;
  missedCallsExternal: number;
  missedCallsInternal: number;
  showClassificationModalForTaskId: string;
  home: {
    searchParams?: SearchParams;
    selectedCustomer?: {
      tenantId: string;
      customerId: string;
    };
  };
};

const defaultState = {
  selectedTaskId: undefined,
  previousSelectedTaskId: undefined,
  missedCallsExternal: 0,
  missedCallsInternal: 0,
  showClassificationModalForTaskId: '',
  home: {
    searchParams: {
      name: '',
      phone: '',
      street: '',
      unit: '',
      zip: '',
    },
    selectedCustomer: null,
  },
};

export function getInitialState(): InboxState {
  const stored = localStorage.getItem('inbox');
  const state = stored ? JSON.parse(stored) : defaultState;

  return {
    ...state,
    home: state.home
      ? { ...defaultState.home, ...state.home }
      : defaultState.home,
  };
}

export const inboxState = proxy<InboxState>(getInitialState());

const setSelectedTaskId = (taskId: string | undefined) => {
  inboxState.previousSelectedTaskId = inboxState.selectedTaskId;
  inboxState.selectedTaskId = taskId;
};

const restorePrevSelectedTaskId = () => {
  // if previousSelectedTaskId is the same as selectedTaskId, then clear it and show the home inbox
  inboxState.selectedTaskId =
    inboxState.selectedTaskId === inboxState.previousSelectedTaskId
      ? undefined
      : inboxState.previousSelectedTaskId;
  inboxState.previousSelectedTaskId = undefined;
};

const setHomeInbox = () => {
  setSelectedTaskId(undefined);
};

const setInboxHomeSearchParams = (searchParams: SearchParams) => {
  if (!inboxState.home) {
    inboxState.home = {};
  }
  inboxState.home.searchParams = searchParams;
};

const setInboxHomeCustomer = (selectedCustomer: any) => {
  if (!inboxState.home) {
    inboxState.home = {};
  }
  inboxState.home.selectedCustomer = selectedCustomer;
};

export const inboxActions = {
  setSelectedTaskId,
  setHomeInbox,
  restorePrevSelectedTaskId,
  setInboxHomeSearchParams,
  setInboxHomeCustomer,
};

subscribe(inboxState, () => {
  localStorage.setItem('inbox', JSON.stringify(inboxState));
});
